export enum OfflinePeriodsEvents {
  OFFLINE_PERIOD_ADD_BUTTON_CLICKED = 'Holiday Period Initial Add Clicked',
  OFFLINE_PERIOD_ADD_SUBMITTED = 'Holiday Period Add Selected',
  OFFLINE_PERIOD_CANCEL_BUTTON_CLICKED = 'Holiday Period Cancellation Initiated',
}

export enum PeriodGranularity {
  DATE = 'Date',
}
